import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-beton-order-cms-form',
  templateUrl: './beton-order-cms-form.component.html',
  styleUrls: ['./beton-order-cms-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BetonOrderCmsFormComponent {}
